import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
// import CallToActionTwo from '../container/CallToAction/CallToActionTwo';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
// import TopicOne from '../container/topic/TopicOne';
// import EmptyOne from '../components/Empty/EmptyOne.jsx';
import EmptyTwo from "../container/Empty/EmptyTwo.js";

const Topic = () => {
  return (
    <React.Fragment>
      <SEO title="Topic Areas | DMBD 2026" />
      <Header />
      <Breadcrumb
        image="images/bg/banner2-opt.jpg"
        title="Topic Areas"
        content="For Authors"
        contentTwo="Topic Areas"
        linkage="/"

      />

      <EmptyTwo>
        <div className="entry-content">
          <table>
            {/* <tbody>
              <tr>
                <th width="140">Data Mining</th>
                <th width="140">Big Data</th>
                <th width="140">FinTech</th>
                <th width="140">Applications</th>
              </tr>
              <tr>
                <td>
                  <ul>
                    <li> Classification and prediction </li>
                    <li> Clustering task</li>
                    <li> Case-Based,Similarity-Based reasoning </li>
                    <li> Mining text, semi-structured, spatio-temporal, streaming, graph,
                      web, multimedia data </li>
                    <li> Systems for data mining </li>
                    <li> Machine learning</li>
                    <li> Reinforcement learning</li>
                    <li> Meta learning</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li> Data models and architectures </li>
                    <li> Deep learning architectures for handling big data </li>
                    <li> Privacy and security in big data analytics</li>
                    <li> Online and adaptive learning for big data streams </li>
                    <li> Data analytics and metrics </li>
                    <li> Tools and technologies QoS in big data </li>
                    <li> Large-scale text generation model</li>
                    <li> Large-scale generative adversarial network</li>
                    <li> Other large-scale model</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li>Quantitative investment</li>
                    <li>Intelligent investment strategy</li>
                    <li>Quantitative strategy</li>
                    <li>Quantization system</li>
                    <li>Market microstructure</li>
                    <li>Risk prediction</li>
                    <li>Credit modeling</li>
                    <li>Financial theories</li>
                    <li>Financial intelligent system</li>
                    <li>Financial Large-scale model</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li> Techniques for Big Data Processing </li>
                    <li>Fraud detection and anomaly detection in large-scale datasets</li>
                    <li>Big data analytics for business intelligence</li>
                    <li>Smart city applications and urban analytics</li>
                    <li>Financial data analysis and stock market prediction</li>
                    <li>Recommender systems for online platforms and personalized recommendations</li>
                    <li>Network security</li>
                    <li>Intelligent diagnosis</li>
                    <li>Other applications</li>
                  </ul>
                </td>
              </tr>
            </tbody> */}
<tbody>
  {/* <!-- Data Mining --> */}
  <tr>
    <th width="140">Data Mining</th>
    <td>
      <ul>
        <li>Classification and prediction</li>
        <li>Clustering task</li>
        <li>Case-based, similarity-based reasoning</li>
        <li>Mining text, semi-structured, spatio-temporal, streaming, graph, web, multimedia data</li>
        <li>Systems for data mining</li>
        <li>Reinforcement learning</li>
        <li>Meta learning</li>
        <li>Fraud detection and anomaly detection</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>

  {/* <!-- Big Data --> */}
  <tr>
    <th width="140">Big Data</th>
    <td>
      <ul>
        <li>Data models and architectures</li>
        <li>Deep learning architectures for handling big data</li>
        <li>Privacy and security in big data analytics</li>
        <li>Online and adaptive learning for big data streams</li>
        <li>Data analytics and metrics</li>
        <li>Tools and technologies QoS in big data</li>
        <li>Big data infrastructure</li>
        <li>Software systems to support big data computing</li>
        <li>Big data open platforms</li>
        <li>Energy-efficient computing for big data</li>
        <li>Autonomic computing and cyber-infrastructure</li>
        <li>High performance/parallel computing platforms</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>

  {/* <!-- Large Language Models --> */}
  <tr>
    <th width="140">Large Language Models</th>
    <td>
      <ul>
        <li>Natural language understanding (NLU)</li>
        <li>Natural language generation (NLG)</li>
        <li>Text summarization</li>
        <li>Machine translation</li>
        <li>Question answering systems</li>
        <li>Dialogue systems and chatbots</li>
        <li>Sentiment analysis</li>
        <li>Named entity recognition (NER)</li>
        <li>Text classification</li>
        <li>Language model fine-tuning</li>
        <li>Multimodal language models</li>
        <li>Ethical considerations in LLMs</li>
        <li>Bias detection and mitigation in LLMs</li>
        <li>LLM applications in healthcare</li>
        <li>LLM applications in legal tech</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>

  {/* <!-- Machine Learning --> */}
  <tr>
    <th width="140">Machine Learning</th>
    <td>
      <ul>
        <li>Supervised learning</li>
        <li>Unsupervised learning</li>
        <li>Semi-supervised learning</li>
        <li>Deep learning</li>
        <li>Transfer learning</li>
        <li>Online learning</li>
        <li>Ensemble learning</li>
        <li>Explainable AI (XAI)</li>
        <li>Time series analysis</li>
        <li>Computer vision</li>
        <li>Natural language processing (NLP)</li>
        <li>Generative models (e.g., GANs, VAEs)</li>
        <li>Federated learning</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>

  {/* <!-- Applications --> */}
  <tr>
    <th width="140">Applications</th>
    <td>
      <ul>
        <li>Techniques for big data processing</li>
        <li>Fraud detection and anomaly detection in large-scale datasets</li>
        <li>Big data analytics for business intelligence</li>
        <li>Smart city applications and urban analytics</li>
        <li>Financial data analysis and stock market prediction</li>
        <li>Recommender systems for online platforms and personalized recommendations</li>
        <li>Network security</li>
        <li>Intelligent diagnosis</li>
        <li>Other applications</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>

  {/* 新增板块3：Big Data Management & Data Ecosystem 大数据管理与数据生态 */}
  <tr>
    <th width="140">Data Management</th>
    <td>
      <ul>
        <li>Big data management</li>
        <li>Compliance and governance for big data</li>
        <li>Multimedia and multi-structured variety data</li>
        <li>Mobility, IoT, sensor and IoE big data</li>
        <li>Cloud/grid/stream velocity data mining</li>
        <li>Data acquisition, integration, cleaning, best practices</li>
        <li>Data ecosystem assessment, valuation, sustainability</li>
        <li>Data exchange, monetization, pricing mechanisms</li>
        <li>Trust management in big data systems</li>
        <li>Fairness, diversity, accountability, transparency studies</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>

  {/* 新增板块4：Foundation Models 基础模型专项（补充原有LLM，覆盖训练全流程） */}
  <tr>
    <th width="140">Foundation Models</th>
    <td>
      <ul>
        <li>Foundation models for big data</li>
        <li>Foundation model operationalization for multiple users</li>
        <li>Prompt engineering and prompt management</li>
        <li>Big data management for pre-training</li>
        <li>Big data management for fine-tuning</li>
        <li>Big data management for prompt-tuning</li>
        <li>Multi-modal foundation models</li>
        <li>AI agents and large model agent systems</li>
        <li>Small-large model hybrid collaboration</li>
        <li>Synthetic data generation for foundation models</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>

  {/* 新增板块6：Big Data Benchmarks & BlueSky Ideas 评测基准与前沿创新方向 */}
  <tr>
    <th width="140">Blue Sky Research</th>
    <td>
      <ul>
        <li>Big data benchmarks & evaluation frameworks</li>
        <li>Responsible dataset development & curation practices</li>
        <li>Benchmarking tools and platforms</li>
        <li>New public datasets and data collections</li>
        <li>Novel interdisciplinary data-AI synthesis</li>
        <li>Paradigm-shifting data & AI applications</li>
        <li>Foundational assumption challenges for traditional algorithms</li>
        <li>Novel algorithmic opportunities for complex hard problems</li>
        <li>Emerging, visionary and bold interdisciplinary concepts</li>
      </ul>
    </td>
  </tr>
  <tr>
    <th width="140"><hr></hr></th>
    <td><hr></hr></td>
  </tr>
</tbody>


          </table>
        </div>
      </EmptyTwo>
      {/* <HomeAbout /> */}
      {/* <EmptyOne>
                <p>
                    yifan
                </p>
            <EmptyOne title="Topic Areas | ICSI 2022"/> */}
      {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
      <Footer />
      <ScrollToTop />
    </React.Fragment>
  );
};

export default Topic;
